// controllers/piece_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "details"];

  async load(event) {
    event.preventDefault();

    const url = event.currentTarget.href;

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      const data = await response.json();
      this.titleTarget.innerHTML = data.html;
    } catch (error) {
      console.error("Error loading piece JSON:", error);
      this.detailsTarget.textContent = "Error loading details.";
    }
  }
}
